// extracted by mini-css-extract-plugin
module.exports = {"storeDescriptionContainer":"_3HEJi","cardStore":"_2b8eL","container":"_2IP-N","imgDesktop":"_6eRz-","imgMobile":"_2Ia7A"};